import React from 'react';
import style from './NumberInputWithUnitDropdown.module.css';
import PropTypes from 'prop-types';

const NumberInputWithUnitDropdown = ({
  list,
  inputVal,
  setInputVal,
  selectVal,
  setSelectVal,
  margin,
  disabled,
  onBlur,
}) => {
  return (
    <div style={{ margin }} className={style.div}>
      <input
        disabled={disabled}
        style={{ borderRadius: '3px 0 0 3px' }}
        className={style.input}
        value={inputVal}
        onChange={({ target }) => setInputVal(target.value)}
        onBlur={({ target }) => onBlur(target.value)}
      />
      <select
        className={style.select}
        value={selectVal}
        onChange={({ target }) => setSelectVal(target.value)}
      >
        {list.map(({ value, text }) => (
          <option key={value} value={value}>
            {text}
          </option>
        ))}
      </select>
    </div>
  );
};
NumberInputWithUnitDropdown.propTypes = {
  list: PropTypes.array.isRequired,
  inputVal: PropTypes.any.isRequired,
  setInputVal: PropTypes.func.isRequired,
  selectVal: PropTypes.string.isRequired,
  setSelectVal: PropTypes.func.isRequired,
  margin: PropTypes.string,
  disabled: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
};
export default NumberInputWithUnitDropdown;
